import { ClinicLocation } from '@/types/admin-clinic-detail';
import { formatPeriodDisplay } from '@/utils/dateConverter';
import type { TableProps } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { AppButton } from '@components/atoms';
import { EllipsisH, Plus } from '@components/atoms/AppIcon';
import AppTable from '@components/atoms/AppTable';

interface ClinicLocationTableProps {
  data: ClinicLocation[];
  clinicId?: number;
  clinicNumber?: string;
  siteType?: string;
}

const ClinicLocationTable = ({
  data,
  clinicId,
  clinicNumber,
  siteType = 'medix',
}: ClinicLocationTableProps) => {
  const navigate = useNavigate();

  const serviceType: Record<string, string> = {
    R2: 'マッサージ',
    A2: 'はり・きゅう',
    BOTH: 'はり・きゅう、マッサージ',
  };

  const columns: TableProps<ClinicLocation>['columns'] = [
    {
      title: 'ID',
      dataIndex: 'order',
      key: 'order',
      width: '10%',
      render: (_, _record, index) => <p>{index + 1}</p>,
    },
    {
      title: '名前',
      dataIndex: 'location_name',
      key: 'location_name',
      width: '170px',
    },
    {
      title: 'サビース',
      dataIndex: 'service_type',
      key: 'service_type',
      render: (_, record) => <p>{serviceType[record.service_type ?? '']}</p>,
      width: '120px',
    },
    {
      title: '有効期限',
      dataIndex: 'date',
      key: 'date',
      render: (_, record) => (
        <p>{formatPeriodDisplay(record.available_from, record.available_to)}</p>
      ),
      width: '220px',
    },
    {
      title: '操作',
      key: 'action',
      width: '100px',
      render: (_, record) => (
        <AppButton
          icon={<EllipsisH />}
          type="primary"
          onClick={() => navigate(`/${siteType}/admin/clinic_locations/${record.id}`)}
        >
          詳細
        </AppButton>
      ),
    },
  ];

  const createUrl =
    clinicId != null
      ? `/${siteType}/admin/clinic_locations/create?clinic_id=${clinicId}`
      : `/${siteType}/admin/clinic_locations/create`;
  const createState =
    clinicId != null ? { clinicId, clinicNumber: clinicNumber ?? undefined } : undefined;

  return (
    <section>
      <div className="flex items-center gap-10 mb-4">
        <h3 className="text-xl">拠点</h3>
        <Link to={createUrl} state={createState}>
          <AppButton icon={<Plus />} type="primary">
            新規
          </AppButton>
        </Link>
      </div>
      <AppTable isAdminSite columns={columns} dataSource={data} rowKey={record => record.id} />
    </section>
  );
};

export default ClinicLocationTable;
